import { formatNumber } from '@angular/common';
import { inject, LOCALE_ID, Pipe, PipeTransform } from '@angular/core';
import { Area } from 'app/shared/ll/models/units';


export const formatAreaMetric = (locale: string, value: any, decimals = 2): string | null => {
    if (!Number.isFinite(value)) {
        return null;
    }
    const area = new Area(value);
    const m = area.getQuantity(false);
    return `${formatNumber(m.value, locale, `1.${decimals}-${decimals}`)} ${m.unit}`;
};


@Pipe({
    name: 'areaMetric',
})
export class AreaMetricPipe implements PipeTransform {

    private locale = inject<string>(LOCALE_ID);

    transform(value: any, decimals = 2): any {
        return formatAreaMetric(this.locale, value, decimals);
    }
}
